<template>
  <v-app id="inspire">
    <v-content>
      <v-container fluid fill-height>
        <v-layout wrap justify-center style="display: flex">
          <v-flex xs3 sm3 md3>
            <v-layout wrap justify-center align-center style="display: flex; margin-top: 15vh;">
            <v-flex xs12 sm12 md12>
            <div class="logo-login">
              <span>ENED</span>
            </div>
            </v-flex>
            <v-flex xs12 sm12 md12>
            <v-form ref="form">
              <label class="label-modal">Username</label>
              <v-text-field
                @keyup.enter.native="login"
                required
                color="#f8ac4a"
                :rules="[() => this.username.length > 0 || required]"
                autocomplete="off"
                prepend-icon="person"
                name="username"
                type="text"
                v-model="username"
              ></v-text-field>
              <label class="label-modal">Password</label>
              <v-text-field
                @keyup.enter.native="login"
                required
                color="#f8ac4a"
                :rules="[() => this.password.length > 0 || required]"
                id="password"
                prepend-icon="lock"
                name="password"
                type="password"
                v-model="password"
              ></v-text-field>
            </v-form>
            </v-flex>
            <v-flex xs12 sm12 md12 justify-end style="display: flex">
              <v-btn v-on:click.stop="login()" color="#f8ac4a" :loading="loading" class="white--text">Entrar</v-btn>
            </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";

export default {
  data: () => ({
    username: "",
    password: "",
    loading: false,
    required: ""
  }),
  created() {
    this.required = '* Campo obrigatório';


    this.$eventBus.$on("loader", (state) => {
      this.loading = state;
    });

  },
  computed: {
    ...mapGetters({
      getSession: "session/getState"
    })
  },
  methods: {
    toast(type, message) {
      if (type == "success") {
        return iziToast.show({
          title: 'SUCESSO',
          color: "green",
          timeout: this.$toastTimeout,
          message: message,
          position: this.$toastPosition
        });
      } else {
        return iziToast.show({
          title: 'ERRO',
          color: "red",
          timeout: this.$toastTimeout,
          message: message,
          position: this.$toastPosition
        });
      }
    },
    login() {
      if (!this.$refs.form.validate()) return;
      this.loading = true;
      this.$store
        .dispatch("session/signIn", {
          username: this.username,
          password: this.password
        })
        .then(res => {
          if (res) {
            this.$eventBus.$emit("login", this.getSession.session);
          } else {
            this.loading = false;
            this.toast("error", 'Os dados introduzidos não são válidos!');
          }
        });
    }
  }
};
</script>
<style scoped>
.logo-login {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  margin-bottom: 5vh !important;
  color: #f8ac4a !important;
  font-weight: bold;
  font-size: 160px;
  letter-spacing: 0 !important;
}

button {
  margin-right: 0 !important;
}

</style>



// WEBPACK FOOTER //
// src/components/Login.vue